<template>
  <div class="TrueFalseCarouselBlock">
    <div class="step"
         v-for="(question, i) in questions"
         v-show="i + 1 === step">
      <h1 class="header primary--text">{{$t('title')}}</h1>
      <h2 class="step-label grey--text">
        <span class="primary--text">{{step}}</span>/{{questions.length}}
      </h2>
      <blockquote class="label">{{question.label}}</blockquote>

      <div class="answer-buttons"
           v-show="answers[i] === null">
        <v-btn class="primary mr-5"
               large
               rounded
               @click="$set(answers, i, true)">{{$t('true_label')}}
        </v-btn>
        <span class="primary--text">Ou</span>
        <v-btn class="primary ml-5"
               large
               rounded
               @click="$set(answers, i, false)">{{$t('false_label')}}
        </v-btn>
      </div>

      <div class="answer-explanation"
           v-show="answers[i] !== null">
        <div class="answer-box"
             :class="answers[i] === question.correct ? 'answer-box-correct' : 'answer-box-incorrect'">
          <h2 class="success--text"
              v-show="answers[i] === question.correct">{{$t('good_answer')}}</h2>
          <h2 class="error--text"
              v-show="!answers[i] === question.correct">{{$t('bad_answer')}}</h2>
          <p class="pt-2">{{question.explanation}}</p>
        </div>
        <v-btn class="primary"
               large
               rounded
               @click="nextStep">{{$t('next')}}
        </v-btn>
      </div>
    </div>

    <div class="end"
         v-show="step > questions.length">
      <div style="display: flex; justify-content: center; align-items: center">
        <h3>{{$t('congrats')}}</h3>
      </div>
      <div class="mt-4 px-4" style="display: flex; justify-content: space-around">
        <span class="green--text">{{$t('correct_answers')}} : {{stats.correct}}</span>
        <span class="red--text">{{$t('incorrect_answers')}} : {{stats.incorrect}}</span>
      </div>
      <div class="mt-4 px-10" style="display: flex; justify-content: space-around; background: white;">
        <div class="green" style="height: 20px; border-radius: 12px 0 0 12px;" :style="{width: ((stats.correct / questions.length) * 100)-1 + '%'}"></div>
        <div class="red" style="height: 20px; border-radius: 0 12px 12px 0;" :style="{width: ((stats.incorrect / questions.length) * 100)-1 + '%'}"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    i18n: {
      messages: {
        fr: {
          title: 'Vrai ou faux ?',
          true_label: 'Vrai',
          false_label: 'Faux',
          bad_answer: 'Mauvaise réponse',
          good_answer: 'Bonne réponse !',
          next: 'Suivant',
          congrats: 'Bravo, vous avez fini ce questionnaire !',
          correct_answers: 'Réponses correctes',
          incorrect_answers: 'Réponses incorrectes'
        },
        en: {
          title: 'True or false ?',
          true_label: 'True',
          false_label: 'False',
          bad_answer: 'Wrong answer',
          good_answer: 'Good answer !',
          next: 'Next',
          congrats: 'Congratulations, you finished this quizz !',
          correct_answers: 'Correct answers',
          incorrect_answers: 'Incorrect answers'
        }
      }
    },

    computed: {
      stats () {
        return {
          correct: this.answers.reduce((acc, cur, i) => {
            return cur === this.questions[i].correct ? acc + 1 : acc
          }, 0),
          incorrect: this.answers.reduce((acc, cur, i) => {
            return cur !== this.questions[i].correct ? acc + 1 : acc
          }, 0)
        }
      }
    },

    data () {
      return {
        answers: [],
        step: 1
      }
    },

    methods: {
      nextStep() {
        this.step++
        if(this.step > this.questions.length) {
          this.$emit('finished', this.stats)
        }
      }
    },

    mounted () {
      this.questions.forEach(question => {
        this.answers.push(null)
      })
    },

    props: {
      questions: {
        required: true,
        type: Array
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .TrueFalseCarouselBlock {
    background: #F8F8F8;
    border-radius: 12px;
    padding: 55px 0;

    .step {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .header {
      font-size: 22px;
    }

    .label:before {
      color: #ccc;
      content: open-quote;
      font-size: 40px;
      line-height: 0.1em;
      margin-right: 0.25em;
    }

    .label {
      padding: 30px 20px;
      font-size: 18px;
      font-weight: 600;
      quotes: "\201C""\201D""\2018""\2019";
      max-width: 650px;
    }

    .answer-explanation {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .answer-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 30px 20px;
      background: #FFF;
      border-radius: 12px;
      max-width: 600px;
      margin: 0 30px 30px 30px;
    }

    .answer-box-correct {
      border: 2px solid #0CA76B;
    }

    .answer-box-incorrect {
      border: 2px solid #F81B35;
    }
  }
</style>
